import { PhoneSectionStyles } from '../../styles/styles';

type Prop = {
  phoneImgSrc: string[];
};

const PhoneSection = (props: Prop) => {
  const { phoneImgSrc } = props;
  return (
    <PhoneSectionStyles data-scroll-section>
      <div
        data-scroll
        data-scroll-speed="2"
        data-scroll-direction="horizontal"
        className="image-wrapper">
        <img src={phoneImgSrc[0]} alt="" />
      </div>
      <div data-scroll data-scroll-speed="4" className="image-wrapper">
        <img src={phoneImgSrc[1]} alt="" />
      </div>
      <div
        data-scroll
        data-scroll-speed="-2"
        data-scroll-direction="horizontal"
        className="image-wrapper">
        <img src={phoneImgSrc[2]} alt="" />
      </div>
    </PhoneSectionStyles>
  );
};

export default PhoneSection;
